import { ReactComponent as IconCrypto } from './assets/icon-crypto.svg';
import { ReactComponent as IconDevices } from './assets/icon-devices.svg';
import { ReactComponent as IconFingerprint } from './assets/icon-fingerprint.svg';
import { ReactComponent as IconUser } from './assets/icon-user.svg';
import { IFeatureItem } from './types';

export const FEATURES: IFeatureItem[] = [
  {
    icon: <IconCrypto />,
    title: 'Designed for real-world assets',
    description:
      'Connects to a licensed security token trading platform for compliant investing.',
  },
  {
    icon: <IconUser />,
    title: 'Issuer-ready by design',
    description:
      'Seamless integration into token launches and compliant platforms.',
  },
  {
    icon: <IconDevices />,
    title: 'Multichain, cross-platform',
    description:
      'Works across multiple blockchains, on both web and mobile—no downloads needed.',
  },
  {
    icon: <IconFingerprint />,
    title: 'Passwordless, seed-optional security',
    description:
      'Passkey login with optional seed phrase—secure and simple, no extra apps.',
  },
];
